import React, { FunctionComponent, ReactElement, useState } from 'react';
import GoogleMap, { Coords, Props } from 'google-map-react';
import './geoMap.scss';
import TimeStamp from '../timeStamp/TimeStamp';
import Loader from '../loader/Loader';

export type MapContainerProps = {
  apiKey: string,
  width: string,
  height: string,
  position?: Coords,
  handleApiLoaded?: (mapObject?: any) => void;
  className?: string,
  timeStamp?: number
  loader?: ReactElement
}

const GeoMap: FunctionComponent<Props & MapContainerProps> = ({
  apiKey,
  width,
  height,
  handleApiLoaded,
  center = { lat: 0, lng: 0 },
  zoom = 12,
  position,
  className = '',
  options,
  timeStamp,
  loader,
}) => {
  const [loading, setLoading] = useState(true);

  const mapLoaded = () => {
    setLoading(false);
  };

  return (
    <div className={`geo-map ${className}`} style={{ width, height }}>
      {loading && (loader || <Loader />)}
      <GoogleMap
        center={center || position}
        defaultZoom={zoom}
        bootstrapURLKeys={{
          key: apiKey,
          libraries: ['drawing'],
        }}
        onGoogleApiLoaded={handleApiLoaded}
        onTilesLoaded={mapLoaded}
        options={{
          disableDefaultUI: true,
          draggable: false,
          keyboardShortcuts: false,
          clickableIcons: false,
          ...options,
        }}
      />
      {timeStamp && (
        <TimeStamp timeInSeconds={timeStamp} className="map-time-stamp" />
      )}
    </div>
  );
};

export default GeoMap;
